import { Box, Tooltip, TextField, InputAdornment } from "@mui/material";
import { ValidationRule, useFormContext } from "react-hook-form";
import { Error } from "@mui/icons-material";
import { useTranslation } from "../../../../../hooks/useTranslation";
import { PricingRule } from "../../PricingSettings";
import React from "react";

type SettingTextfieldProps = {
  name: keyof PricingRule;
  startAdornment?: React.ReactNode;
  max?: ValidationRule<number | string>;
  required?: boolean;
};

export const SettingTextfield = (props: SettingTextfieldProps) => {
  const { name, startAdornment, max, required = true } = props;
  const { translate } = useTranslation("pages.stores.pricingSettings");

  const {
    register,
    formState: { errors },
  } = useFormContext<PricingRule>();

  return (
    <Box position="relative" display="inline-flex" alignItems="center">
      {errors[name] && (
        <Tooltip title={errors[name]?.message ?? ""} placement="top">
          <Error
            color="error"
            sx={{ position: "absolute", right: -8, top: -4, zIndex: 1000 }}
          />
        </Tooltip>
      )}
      <TextField
        margin="none"
        size="small"
        type="number"
        sx={{ width: "100px" }}
        error={!!errors[name]}
        {...register(name, {
          valueAsNumber: true,
          max: max,
          min: { value: 0, message: translate("errors.min") },
          required: required ? translate("errors.required") : undefined,
        })}
        slotProps={
          startAdornment
            ? {
                input: {
                  startAdornment: (
                    <InputAdornment position="start">
                      {startAdornment}
                    </InputAdornment>
                  ),
                },
              }
            : {}
        }
      />
    </Box>
  );
};
